module.exports = "<p>\n  role-query works!\n</p>\n"